
import {
  Form,
  Checkbox,
  FormItem,
  Input,
  DatePicker,
  Button,
} from 'element-ui';

export default {
  data() {
    return {
      customCard: false,
      form: {
        firstName: '',
        lastName: '',
        mobilePhone: '',
        email: '',
        message: '',
        dateSend: '',
      },
      rules: {
        email: [
          {
            required: true,
            type: 'email',
            message: this.$t ? this.$t('Required Field') : 'Required Field',
            trigger: 'blur',
          },
        ],
      },
      datePickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },
    };
  },
  methods: {
    submit() {
      if (!this.customCard) {
        this.$emit('submit', null);
        return Promise.resolve(null);
      }

      return new Promise((resolve, reject) => {
        this.$refs.giftCardForm.validate((valid) => {
          if (valid) {
            const payload = { ...this.form };
            this.$emit('submit', payload);
            resolve(payload);
          }
        });
      });
    },
  },

  components: {
    Checkbox,
    FormItem,
    Input,
    Form,
    DatePicker,
    Button,
  },
};
